import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { SurveyInterface } from '../../+models';
import { SurveysActions, SurveysActionTypes } from './survey.actions';

export const NAME = 'surveys';

export interface State extends EntityState<SurveyInterface> {
  // additional entities state properties
  loaded: boolean;
  error?: any;
}

export const adapter: EntityAdapter<SurveyInterface> = createEntityAdapter<SurveyInterface>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loaded: false,
});

export function reducer(state = initialState, action: SurveysActions): State {
  switch (action.type) {
    case SurveysActionTypes.AddSurvey: {
      return adapter.addOne(action.payload.survey, state);
    }

    case SurveysActionTypes.UpsertSurvey: {
      return adapter.upsertOne(action.payload.survey, state);
    }

    case SurveysActionTypes.AddSurveys: {
      return adapter.addMany(action.payload.surveys, state);
    }

    case SurveysActionTypes.UpsertSurveys: {
      return adapter.upsertMany(action.payload.surveys, state);
    }

    case SurveysActionTypes.UpdateSurvey: {
      return adapter.updateOne(action.payload.survey, state);
    }

    case SurveysActionTypes.UpdateSurveys: {
      return adapter.updateMany(action.payload.surveys, state);
    }

    case SurveysActionTypes.DeleteSurvey: {
      return adapter.removeOne(action.payload.id, state);
    }

    case SurveysActionTypes.DeleteSurveys: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case SurveysActionTypes.SurveysLoaded: {
      return adapter.setAll(action.payload.surveys, {
        ...state,
        loaded: true,
      });
    }

    case SurveysActionTypes.SurveysLoadError: {
      return { ...state, error: action.payload, loaded: false };
    }

    case SurveysActionTypes.ClearSurveys: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
